import WeeklyAlarmComplete from "@src/pages/weeklyAlarm/WeeklyAlarmComplete";
import { lazy } from "react";

const WeeklyAlarmApply = lazy(() => import("../pages/weeklyAlarm/WeeklyAlarmApply"));

export const weeklyAlarmRoutes = [
  { path: "/weekly-alarm/apply", element: <WeeklyAlarmApply /> },
  { path: "/weekly-alarm/complete", element: <WeeklyAlarmComplete /> },
];
